// assets
import { IconUser, IconPalette, IconShadow, IconWindmill, IconShieldCheck, IconFlag, IconBan, IconPhoto } from '@tabler/icons';

// constant
const icons = {
    IconUser,
    IconPalette,
    IconShadow,
    IconWindmill,
    IconShieldCheck,
    IconFlag,
    IconBan,
    IconPhoto
};

// ==============================|| UTILITIES MENU ITEMS ||============================== //

const utilities = {
    id: 'utilities',
    title: '일반 설정',
    type: 'group',
    children: [
        {
            id: 'Employee',
            title: '관리자',
            type: 'item',
            url: 'employee',
            icon: icons.IconShieldCheck,
            breadcrumbs: false
        },
        {
            id: 'Users',
            title: '회원',
            type: 'item',
            url: 'users',
            icon: icons.IconUser,
            breadcrumbs: false
        },
        {
            id: 'Report',
            title: '신고',
            type: 'item',
            url: 'report',
            icon: icons.IconFlag,
            breadcrumbs: false
        },
        {
            id: 'Penalty',
            title: '차단',
            type: 'item',
            url: 'penalty',
            icon: icons.IconBan,
            breadcrumbs: false
        },
        {
            id: 'PhotoRequest',
            title: '사진 요청',
            type: 'item',
            url: 'photo_request',
            icon: icons.IconPhoto,
            breadcrumbs: false
        },


    ],


};

export default utilities;
